import { createTPluginFactory } from '../../plate';
import { KEY_COLLECTION_CONNECT_DATA } from '../../pluginKeys';
import CollectionDataElement from './components/CollectionDataElement';
import { CollectionDataPluginOptions } from './types';

export const createCollectionDataPlugin = createTPluginFactory<CollectionDataPluginOptions>({
  key: KEY_COLLECTION_CONNECT_DATA,
  isLeaf: true,
  component: CollectionDataElement,
  options: {
    showSchema: false,
  },
});
